"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubFormLinkService = void 0;
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const core_shared_2 = require("@ikegps/core-shared");
const field_transform_1 = require("./field.transform");
const LINK_SUBFORM_INSTANCE = true;
class SubFormLinkService {
    constructor() {
        this.__priority = 100;
    }
    isSubFormCompatible(form) {
        return this.getRules(form) != null;
    }
    findLinks(collection, candidateCollections) {
        const subFormLinks = [];
        const location = collection.location;
        const fields = collection.schema.fields.slice();
        while (fields.length > 0) {
            const fieldSchema = fields.pop();
            if (fieldSchema.type !== core_api_1.IkeFieldType.FORM) {
                continue;
            }
            const subform = collection.getField(fieldSchema.id);
            const rules = this.getRules(subform.schema);
            if (rules == null) {
                fields.push.apply(fields, subform.value);
                continue;
            }
            for (const candidateCollection of candidateCollections) {
                const subFormLink = this.getLink(rules, subform, location, candidateCollection);
                if (subFormLink != null) {
                    subFormLinks.push(subFormLink);
                }
            }
        }
        return subFormLinks;
    }
    copySubForm(collection, subFormLinkRecord) {
        const instance = subFormLinkRecord.instance;
        const targetSubForm = collection.getField(instance.schema.id);
        const targetSubFormInstance = targetSubForm.Mutator.copyInstance(instance.parent, instance.instanceId, LINK_SUBFORM_INSTANCE);
        const rules = this.getRules(targetSubFormInstance.schema);
        targetSubFormInstance.forEachField(field => {
            const transform = field_transform_1.FieldTransform.create(field, rules.fields[field.schema.id]);
            if (transform == null) {
                return;
            }
            transform.apply(field);
        });
        // Remove measurements which link to external captures
        const externalCaptureIds = this.getCaptureIds(subFormLinkRecord.collection, targetSubFormInstance);
        targetSubFormInstance.forEachField(field => {
            if (!core_shared_2.CollectionModelFieldHeight.isHeightField(field) || !field.isPhotoMeasure()) {
                return;
            }
            const stateValue = field.stateValue;
            const drawableState = collection.getDrawableState(stateValue.captureId);
            const drawable = drawableState.getDrawable(stateValue.drawable);
            if (externalCaptureIds[drawable.captureId]) {
                field.Mutator.unlink();
            }
        });
        return targetSubFormInstance;
    }
    getLink(rules, subform, location, candidateCollection) {
        const candidateSubForm = candidateCollection.getField(subform.schema.id);
        if (candidateSubForm == null || !candidateSubForm.hasValue()) {
            return null;
        }
        const candidateLocation = candidateCollection.location;
        const subFormLinks = [];
        for (const candidateInstance of candidateSubForm.value) {
            if (subform.getInstance(candidateInstance.instanceId) != null) {
                continue;
            }
            // Check if any rules reject any field in the candidate instance
            if (!this.matchesRules(rules, candidateInstance)) {
                continue;
            }
            const vectorField = candidateInstance.getField(rules.vector);
            const distance = this.getDistance(candidateLocation, vectorField, location);
            if (distance == null || distance >= rules.distance) {
                continue;
            }
            subFormLinks.push({
                collection: candidateCollection,
                instance: candidateInstance,
                distance
            });
        }
        subFormLinks.sort(this.sortSubFormLinkRecords);
        return subFormLinks[0];
    }
    matchesRules(rules, instance) {
        return instance.forEachField(field => {
            const transform = field_transform_1.FieldTransform.create(field, rules.fields[field.schema.id]);
            if (transform == null) {
                return true;
            }
            return transform.match(field);
        });
    }
    getDistance(sourceLocation, sourceVectorField, targetLocation) {
        let spanLocation1 = null;
        let spanLocation2 = null;
        if (sourceVectorField.provider === core_shared_2.CollectionModelFieldVector.PROVIDER_P2P) {
            const captures = sourceVectorField.getCaptures();
            spanLocation1 = captures[0].target;
            spanLocation2 = captures[1].target;
        }
        else if (sourceVectorField.provider === core_shared_2.CollectionModelFieldVector.PROVIDER_MANUAL || sourceVectorField.provider === core_shared_2.CollectionModelFieldVector.PROVIDER_COLLECTION) {
            spanLocation1 = core_shared_1.IkeGeodesic.projectLocation(sourceLocation, sourceVectorField.value.bearing, sourceVectorField.value.distance);
            spanLocation2 = sourceLocation != null ? sourceLocation : spanLocation1;
        }
        else {
            return null;
        }
        const distance1 = core_shared_1.IkeGeodesic.getDistance(targetLocation, spanLocation1);
        const distance2 = core_shared_1.IkeGeodesic.getDistance(targetLocation, spanLocation2);
        return Math.min(distance1, distance2);
    }
    getCaptureIds(collection, subformInstance) {
        const captureIds = {};
        collection.forEachField(field => {
            if (core_shared_1.CaptureProvider.isCaptureProvider(field)) {
                for (const capture of field.getCaptures()) {
                    captureIds[capture.objectId] = true;
                }
            }
        });
        subformInstance.forEachField(field => {
            if (core_shared_1.CaptureProvider.isCaptureProvider(field)) {
                for (const capture of field.getCaptures()) {
                    delete captureIds[capture.objectId];
                }
            }
        });
        return captureIds;
    }
    sortSubFormLinkRecords(record1, record2) {
        return record1.distance - record2.distance;
    }
    getRules(form) {
        for (const provider of form.providers) {
            if (provider == null) {
                continue;
            }
            if (typeof provider === 'object') {
                if (provider.type === core_api_1.IkeProviderType.EXISTING_SPAN) {
                    return provider;
                }
            }
            else if (provider === core_api_1.IkeProviderType.EXISTING_SPAN) {
                return core_shared_2.IkeCalcExistingSpanLegacyProvider;
            }
        }
        return null;
    }
}
exports.SubFormLinkService = SubFormLinkService;
//# sourceMappingURL=subform.link.service.js.map